/**
 * Shared app-level config/constants/side-effects.
 *
 * Extracted verbatim from the original src/App.js (structural refactor only).
 * Importing this module (even just for its side effects) registers the axios
 * interceptors exactly once at app boot, matching the original behavior
 * where App.js was the single entrypoint module.
 */
import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// --- Autenticação admin via header Authorization (Bearer) ---
// Anexa o token do admin em todas as chamadas /admin/* (exceto login)
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  if (url.includes('/admin/') && !url.includes('/admin/login')) {
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

// Sessão expirada (401): limpa o token e avisa a aplicação
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    if (error.response?.status === 401 && url.includes('/admin/') && !url.includes('/admin/login')) {
      localStorage.removeItem('admin_token');
      window.dispatchEvent(new Event('admin-session-expired'));
    }
    return Promise.reject(error);
  }
);

// Lista estática de departamentos (fallback): usada quando a empresa ainda
// não tem setores cadastrados dinamicamente (db.sectors) nem histórico
// migrado, ou quando a busca de setores falha. Mantém o comportamento
// exatamente como era antes desta funcionalidade para essas empresas.
export const DEFAULT_DEPARTMENTS = [
  { value: 'rh', label: '👥 Recursos Humanos' },
  { value: 'ti', label: '💻 Tecnologia da Informação' },
  { value: 'financeiro', label: '💰 Financeiro' },
  { value: 'operacional', label: '⚙️ Operacional/Produção' },
  { value: 'comercial', label: '📊 Comercial' },
  { value: 'administrativo', label: '📋 Administrativo' },
  { value: 'servicos-gerais', label: '🧹 Serviços Gerais/Limpeza' },
  { value: 'outro', label: '📌 Outro' },
];

// Cache simples em memória (dura enquanto a aba estiver aberta) dos setores
// já buscados por tag de empresa, para evitar refetch ao navegar entre
// etapas do formulário.
export const sectorsCache = {};

// Update page title
export const updatePageTitle = (subtitle = '') => {
  const baseTitle = 'Avaliação Psicossocial - DEMoraes Consultoria';
  document.title = subtitle ? `${subtitle} - ${baseTitle}` : baseTitle;
};
